import mainVersionOneService from 'services/mainVersionOneService';

export function vesselCategoriesList() {
    return mainVersionOneService
        .get(`vesselCategories/list`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
